import { publishSellingPlanChangedEvent } from '../../events/selling-plan-changed'
import { SellingPlanGroup } from '../../models/selling-plan-group'
import { dispatchEvent } from '../../services/analytics/events'
import { widgetState } from '../customizations/index'
import { sellingPlansState } from './index'

export const setSellingPlanGroups = (sellingPlanGroups: SellingPlanGroup[]) => {
  sellingPlansState.sellingPlanGroups = sellingPlanGroups.slice(0)
}

export const setSelectedSellingPlan = (sellingPlanGroupId: string, sellingPlanId: string) => {
  sellingPlansState.selectedSellingPlanGroupId = sellingPlanGroupId
  sellingPlansState.selectedSellingPlanId = sellingPlanId
}
export const setSellingPlanChange = (groupId: string, selectedSellingPlanId: string, isSubscription: boolean, productId: string, isDiscountAvailable: boolean) => {
  setSelectedSellingPlan(groupId, selectedSellingPlanId)
  publishSellingPlanChangedEvent({
    selectedGroupId: groupId,
    selectedSellingPlanId,
    isBuyOnce: !isSubscription
  })
  if (groupId !== 'buy-once') {
    dispatchEvent({
      action: 'clicked_on',
      context: {
        product_id: productId,
        selling_plan_id: selectedSellingPlanId,
        selected_group_id: groupId,
        live_preview: widgetState.customizations.livePreview.show
      }
    })
  }
}
